export default {
  methods: {
    setColours(org) {
      this.$log.info('setting colours', org?.id);
      switch (this.organization?.id) {
        default:
        case 1:
          this.$vuetify.theme.themes.light.primary = '#518fc8';
          break;
        case 2:
          this.$vuetify.theme.themes.light.primary = '#234508';
          break;
      }
    },
  },
};
